import { useState, useEffect } from 'react';

import throttle from 'lodash.throttle';

export type TUseScrollPosition = (
  elementRef: React.MutableRefObject<HTMLElement | null>,
  throttleMs?: number
) => {
  x: number;
  y: number;
};

export const useScrollPosition: TUseScrollPosition = (ref, throttleMs) => {
  const [state, setState] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    if (!ref?.current) {
      return;
    }

    const refCurrent = ref.current;

    const throttledHandler = throttle((): void => {
      setState({
        x: refCurrent.scrollLeft,
        y: refCurrent.scrollTop,
      });
    }, throttleMs);

    refCurrent.addEventListener('scroll', throttledHandler);

    return (): void => {
      refCurrent.removeEventListener('scroll', throttledHandler);
    };
  }, [ref, throttleMs]);

  return state;
};
